import { Action } from '@ngrx/store';
import { ErrorResponse, QueryOptions } from '~shared/models';
import { BrandSearchResponse } from '~app/modules/brand-plp/models';

export enum ProductsActionTypes {
  LOAD_PRODUCTS = '[BrandPLP] Products Load',
  RESET_PRODUCTS = '[BrandPLP] Products Reset',
  LOAD_PRODUCTS_SUCCESS = '[BrandPLP] Products Load Success',
  LOAD_PRODUCTS_FAILURE = '[BrandPLP] Products Load Failure',
  APPEND_PRODUCTS = '[BrandPLP] Products Append',
  APPEND_PRODUCTS_SUCCESS = '[BrandPLP] Products Append Success',
  APPEND_PRODUCTS_FAILURE = '[BrandPLP] Products Append Failure',
}

export class LoadProducts implements Action {
  readonly type = ProductsActionTypes.LOAD_PRODUCTS;

  constructor(public payload: {queryOptions: QueryOptions}) {
  }
}

export class AppendProducts implements Action {
  readonly type = ProductsActionTypes.APPEND_PRODUCTS;

  constructor(public payload: {queryOptions: QueryOptions}) {
  }
}

export class ResetProducts implements Action {
  readonly type = ProductsActionTypes.RESET_PRODUCTS;

  constructor() {
  }
}

export class AppendProductsSuccess implements Action {
  readonly type = ProductsActionTypes.APPEND_PRODUCTS_SUCCESS;

  constructor(public payload: BrandSearchResponse) {
  }
}

export class AppendProductsFailure implements Action {
  readonly type = ProductsActionTypes.APPEND_PRODUCTS_FAILURE;

  constructor(public payload: {error: ErrorResponse}) {
  }
}

export class LoadProductsSuccess implements Action {
  readonly type = ProductsActionTypes.LOAD_PRODUCTS_SUCCESS;

  constructor(public payload: { response: BrandSearchResponse, queryOptions: QueryOptions } ) {
  }
}

export class LoadProductsFailure implements Action {
  readonly type = ProductsActionTypes.LOAD_PRODUCTS_FAILURE;

  constructor(public payload: {error: ErrorResponse}) {
  }
}

export type ProductsActionsUnion = LoadProducts
| ResetProducts
| LoadProductsSuccess
| LoadProductsFailure
| AppendProducts
| AppendProductsSuccess
| AppendProductsFailure;
